import { createStyles } from 'antd-style';

export const usePreferenceStyles = createStyles(({ css, token }) => ({
  content: css`hr { border: 0; border-top: 1px solid ${token.colorBorderSecondary}; margin: 24px 0; }`,
  section: css`
    margin-bottom: 16px;
    h3 { margin: 8px 0 12px; font-size: 14px; color: ${token.colorTextHeading}; }
  `,
  row: css`
    display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 8px 0;
    .ant-select { flex: 0 0 160px; max-width: 100%; }
  `,
  choices: css`&.ant-radio-group { display: flex; flex-wrap: wrap; gap: 16px; min-height: 42px; }`,
  choice: css`
    width: 44px; height: 36px; position: relative; border-radius: 4px;
    &:has(input:focus-visible) { outline: 2px solid ${token.colorPrimary}; outline-offset: 3px; }
  `,
  preview: css`
    position: absolute; inset: 0; overflow: hidden; border-radius: 4px; background: #fff; pointer-events: none;
    border: 1px solid ${token.colorBorder};
    .preview-side { position: absolute; inset: 0 auto 0 0; width: 14px; background: #001529; }
    .preview-header { position: absolute; inset: 0 0 auto 0; height: 9px; background: #edf0f4; }
    .preview-lines { position: absolute; top: 13px; right: 4px; width: 21px; height: 13px; background: repeating-linear-gradient(to bottom, #cbd5e1 0 2px, transparent 2px 5px); }
    &[data-preview='light'] .preview-side { background: #f2f4f7; }
    &[data-preview='dark'] { background: #242424; }
    &[data-preview='dark'] .preview-side { background: #101010; }
    &[data-preview='dark'] .preview-header { background: #191919; }
    &[data-preview='side'] .preview-side { z-index: 1; }
    &[data-preview='top'] .preview-side { display: none; }
    &[data-preview='top'] .preview-header { background: #001529; }
    &[data-preview='mixed'] .preview-side { top: 9px; z-index: 1; }
    &[data-preview='mixed'] .preview-header { left: 0; background: #64748b; }
    &[data-preview='single'] .preview-side, &[data-preview='serviceGrid'] .preview-side { display: none; }
    &[data-preview='single'] .preview-lines { width: 34px; }
    &[data-preview='serviceGrid'] .preview-lines, &[data-preview='splitServiceGrid'] .preview-lines { background: repeating-linear-gradient(to bottom, #cbd5e1 0 4px, transparent 4px 7px); clip-path: polygon(0 0,44% 0,44% 100%,56% 100%,56% 0,100% 0,100% 100%,0 100%); }
    &[data-preview='serviceGrid'] .preview-lines { width: 34px; }
    &[data-preview='twoColumn'] .preview-side, &[data-preview='splitServiceGrid'] .preview-side { width: 9px; }
    &[data-preview='twoColumn'] .preview-lines, &[data-preview='splitServiceGrid'] .preview-lines { width: 26px; }
    &[data-preview='system'] { display: grid; place-items: center; font-size: 20px; color: #334155; }
    .preview-check { position: absolute; right: 4px; bottom: 3px; z-index: 2; color: ${token.colorPrimary}; font-size: 14px; }
  `,
  labeledChoice: css`
    && { width: 92px; height: 72px; }
    & > span:last-child { width: 100%; }
    [data-preview] { inset: 0 auto auto 24px; width: 44px; height: 36px; }
  `,
  choiceLabel: css`display: block; padding-top: 44px; text-align: center; font-size: 12px;`,
  swatches: css`display: flex; flex-wrap: wrap; gap: 8px; padding-top: 8px;`,
  swatch: css`
    &&.ant-btn { width: 20px; min-width: 20px; height: 20px; padding: 0; border: 0; border-radius: 2px; }
    @media (pointer: coarse), (max-width: 767px) { &&.ant-btn { width: 44px; min-width: 44px; height: 44px; } }
  `,
}));
